<div class="snkbar">
  <div [class]="['snkbar__icon', cssClass]">
    @if (data.type === 'success') {
    <mat-icon>check_circle</mat-icon>
    } @if (data.type === 'failure') {
    <mat-icon>cancel</mat-icon>
    } @if (data.type === 'warning') {
    <mat-icon>warning</mat-icon>
    } @if (data.type === 'neutral') {
    <mat-icon>info</mat-icon>
    }
  </div>
  <div class="snkbar__content">
    {{ data.message }}
  </div>
  @if (data.action) {
  <div class="snkbar__action">
    <a (click)="action()" class="snkbar__link">{{ data.action }}</a>
  </div>
  } @if (data.closable) {
  <div class="snkbar__close">
    <a (click)="close()" class="snkbar__closelink">
      <mat-icon class="snkbar__closelinkicon">close</mat-icon>
    </a>
  </div>
  }
</div>
